import React, { useEffect, useState, useRef, Fragment } from 'react';
import { connect } from 'react-redux';
import { Wrapper, Close, Container, Content, Image, Picture, speedAnimation, Svg, Share } from './styled';
import { imagesSrc } from './imagesSrc';
import Texts from './Texts/index';
import Answers from './Answers';
import Control from './Control';
import { checkAnswers, dataLayerParams, getProducts, getProductsAliasFromQuestions } from '~/src/helpers/quiz';
import QuizTariff from '~/src/components/QuizBlock/QuizTariff';
import { dataLayerPush } from '@ertelecom/ui-react/components/helpers';
import { changeAnswersAction, nextStepAction, setTariffsForQuizAction } from '~/src/store/actions/quiz';
import { textsForTariff } from './texts';
import { Button, ButtonsItem, Buttons } from './Control/styled';
import { openChat } from '~/src/store/actions/chat';
import { setRouters } from '~/src/store/actions/routers';
import { setTvBoxes } from '~/src/store/actions/tvboxes';
import { hasProp } from '~/src/helpers/object';
import { ACTIONS } from '~/src/constants/analytics';

const Quiz = ({
    clickOnClose,
    stepQuiz,
    questions,
    showTariff,
    tariff,
    router,
    tvBox,
    isSended,
    error,
    isSendError,
    cityDomain,
    openChannelsPopUp,
    nextStep,
    changeAnswers,
    showChat,
    cityId,
    setRouters,
    setTvBoxes,
    setTariffsForQuiz
}) => {

    const [show, setShow] = useState(false);

    const wrapper = useRef(null);

    const setProducts = async(questions,  cityDomain, cityId) => {
        const products = await getProducts(getProductsAliasFromQuestions(questions), cityDomain, cityId);
        if (products.tariffs) {
 setTariffsForQuiz(products.tariffs);
}
        if (products.routers) {
 setRouters(products.routers);
}
        if (products.tvBoxes) {
 setTvBoxes(products.tvBoxes);
}
    };

    useEffect(() => {
        const timeout = setTimeout(() => {
            setShow(true);
            clearTimeout(timeout);
        }, 100);
        if (questions && questions.length > 0) {
 setProducts(questions, cityDomain, cityId);
}
    }, []);

    const [disabledButton, setDisabledButton] = useState(true);

    useEffect(() => {
        // проверка, выбран ли ответ, чтобы передать в кнопку значение disabled
        const disabledButtonNew = questions[stepQuiz] ? !checkAnswers(questions[stepQuiz].answers) : true;
        if (disabledButton !== disabledButtonNew) {
 setDisabledButton(disabledButtonNew);
}
    }, [stepQuiz, questions]);

    // анимирование при смене шагов
    const [isVisibleContent, setIsVisibleContent] = useState(true);
    useEffect(() => {
 setIsVisibleContent(true);
}, [stepQuiz]);

    // анимирование при появлении тарифа
    const [isShowTariff, setIsShowTariff] = useState(false);
    useEffect(() => {
        if (showTariff) {
            const timeout = setTimeout(() => {
                setIsShowTariff(true);
                setIsVisibleContent(true);
                clearTimeout(timeout);
            }, speedAnimation);
        }
    }, [showTariff]);

    useEffect(() => {
        if (error || isSendError) {
            dataLayerPush(dataLayerParams({ category: 'quiz game', action: ACTIONS.error }));
        }
    }, [error, isSendError]);

    const closeQuiz = () => {
        setShow(false);
        const timeout = setTimeout(() => {
            clickOnClose();
            clearTimeout(timeout);
        }, speedAnimation);

    };

    const onClickRadio = index => {

        const currentAnswers = [...questions[stepQuiz].answers];

        const newCurrentAnswers = currentAnswers.map((answer, id) => {
            const currentAnswer = { ...answer };

            (id === index) ? currentAnswer.selected = true
                : currentAnswer.selected = false;

            return currentAnswer;
        });

        const newQuestions = [...questions];
        newQuestions[stepQuiz].answers = newCurrentAnswers;

        changeAnswers([...newQuestions]);

        if (stepQuiz < questions.length - 1) {

            const timeoutAnimation = setTimeout(() => {

                setIsVisibleContent(false);

                clearTimeout(timeoutAnimation);
            }, speedAnimation);

            const timeout = setTimeout(() => {

                if (wrapper) {
 wrapper.current.scrollTop = 0;
}

                nextStep(stepQuiz + 1);
                dataLayerPush(dataLayerParams({ category: 'quiz game', action: `step ${stepQuiz + 1}` }));

                clearTimeout(timeout);
            }, speedAnimation * 2);
        }
    };

    const onClickCheckbox = index => {

        const targetAnswerSelected = hasProp(questions[stepQuiz].answers[index], 'selected')
            ? questions[stepQuiz].answers[index].selected
            : false;

        const newQuestions = [...questions];
        newQuestions[stepQuiz].answers[index].selected = !targetAnswerSelected;

        changeAnswers([...newQuestions]);
    };

    let dataPicture = null;
    if (!showTariff) {
        dataPicture = imagesSrc.questions[stepQuiz];
    } else {
        if (!imagesSrc.tariff[tariff.indexTypeTariffStep]) {
            const tariffsLength = imagesSrc.tariff.length - 1;
            tariff.indexTypeTariffStep = tariffsLength;
        }
        dataPicture = imagesSrc.tariff[tariff.indexTypeTariffStep];
    }
    if (isSended) {
 dataPicture = imagesSrc.sended;
}
    if (isSendError) {
 dataPicture = imagesSrc.error;
}

    const renderPicture = mobile => (
        <Picture isShowTariff={isShowTariff} mobile={mobile}>
            <Svg viewBox='0 0 836 738' fill='none' active={isVisibleContent}>
                <path d={dataPicture.svg} fill={dataPicture.color}/>
            </Svg>
            {
                imagesSrc.questions.map((item, index) => {
                    return (
                        <Image
                            key={index} src={item.image}
                            active={index === stepQuiz && !showTariff && !isSended && !isSendError}
                        />
                    );
                })
            }
            {
                imagesSrc.tariff.map((item, index) => {
                    return (
                        <Image
                            tariff
                            key={index} src={item.image}
                            active={
                                tariff &&
                                index === tariff.indexTypeTariffStep &&
                                showTariff &&
                                !isSended &&
                                !isSendError
                            }
                        />
                    );
                })
            }
            <Image
                tariff
                key={'sended'} src={imagesSrc.sended.image}
                active={isSended}
            />
            <Image
                tariff
                key={'error'} src={imagesSrc.error.image}
                active={isSendError}
            />
        </Picture>
    );

    return (
        <Wrapper show={show} ref={wrapper}  bgColor={dataPicture.color}>
            <Container>
                {renderPicture(false)}
                <Content isVisible={isVisibleContent}>
                    <Texts textsForTariff={tariff && textsForTariff[tariff.indexTypeTariffStep]} />
                    {renderPicture(true)}
                    {
                        (isShowTariff && (tariff || router || tvBox) && !isSended && !error && !isSendError)
                            ?   <Fragment>
                                    <Share
                                        mobile
                                        url={window.location}
                                        title={tariff.tariff_name_display}
                                        description={(tariff.description && tariff.description.description) ? tariff.description.description : ''}
                                        image={'https://' + window.location.host + dataPicture.image}
                                    />
                                    <QuizTariff
                                        tariff={tariff ? tariff : null}
                                        router={router ? router : null}
                                        tvBox={tvBox ? tvBox : null}
                                        aliases={getProductsAliasFromQuestions(questions)}
                                        cityDomain={cityDomain}
                                        openChannelsPopUp={openChannelsPopUp}
                                        outline={false}
                                        textButton='Получить награду'
                                    />
                                    <Share
                                        url={window.location}
                                        title={tariff.tariff_name_display}
                                        description={(tariff.description && tariff.description.description) ? tariff.description.description : ''}
                                        image={'https://' + window.location.host + dataPicture.image}
                                    />
                                </Fragment>
                            : <Answers
                                    onClickCheckbox={onClickCheckbox}
                                    onClickRadio={onClickRadio}
                                />
                    }
                    {
                        (questions[stepQuiz].multiple || stepQuiz === questions.length - 1) && !showTariff &&
                        <Control disabled={disabledButton} wrapper={wrapper} setIsVisibleContent={setIsVisibleContent} />
                    }
                    {
                        (isSended || isSendError) &&
                        <Buttons>
                            <ButtonsItem key='1'>
                                <Button
                                    text={isSended ? 'Ок, спасибо' : 'Написать в чат'}
                                    onClick={isSended ? closeQuiz : showChat}
                                />
                            </ButtonsItem>
                            {
                                isSendError &&
                                <ButtonsItem key='2'>
                                    <Button
                                        text='Вернуться на главную'
                                        onClick={() => window.location = '/'}
                                        type='secondary'
                                    />
                                </ButtonsItem>
                            }
                        </Buttons>
                    }
                </Content>
            </Container>
            <Close onClick={closeQuiz}/>
        </Wrapper>
    );
};

Quiz.defaultProps = {
    stepQuiz: 0,
    questions: [],
    openChannelsPopUp: () => null
};

const mapStateToProps = state => ({
    cityDomain: state.city.currentCity.domain,
    cityId: state.city.currentCity.cityId,
    stepQuiz: state.quiz.stepQuiz,
    questions: state.quiz.questions,
    showTariff: state.quiz.showTariff,
    error: state.quiz.error,
    tariff: state.quiz.pickedUpTariff,
    router: state.quiz.pickedUpRouter,
    tvBox: state.quiz.pickedUpTvBox,
    isSended: state.quiz.isSended,
    isSendError: state.quiz.isSendError
});

const mapDispatchToProps = dispatch => ({
    nextStep: stepNumber => dispatch(nextStepAction(stepNumber)),
    changeAnswers: (questions, stepQuizCheck) => dispatch(changeAnswersAction(questions, stepQuizCheck)),
    showChat: () => dispatch(openChat()),
    setTariffsForQuiz: tariffs => dispatch(setTariffsForQuizAction(tariffs)),
    setRouters: routers => dispatch(setRouters(routers)),
    setTvBoxes: tvBoxes => dispatch(setTvBoxes(tvBoxes))
});

export default connect(mapStateToProps, mapDispatchToProps)(Quiz);
